import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/subscriber/history/')({
  beforeLoad: () => {
    throw redirect({ to: '/subscriber/history/reading' });
  },
});
